import React from "react";
import { useSelector } from "react-redux";
import { Grid, Paper, Typography, Box, Tooltip, makeStyles} from "@material-ui/core";
import Icon from '@material-ui/core/Icon'

import { getColorStyle, getTrendIcon, getTrendColor, getPreviousPeriodText } from "../../../../components/common/Common";
import { getMetric } from "../../../../store/hub/conversionMetrics";

export default function ConversionWidget({
  metric1IdAndValue,
  metric2IdAndValue,
  paperClassName,
}) {

  const classes = useStyles();
  
  const metric1 = useSelector((state) => getMetric(state.entities.conversionMetrics, metric1IdAndValue.id));
  let metric2Id = null;
  if (metric2IdAndValue) {
    metric2Id = metric2IdAndValue.id;
  }
  const metric2 = useSelector((state) => getMetric(state.entities.conversionMetrics, metric2Id));

  try {
    return (
      <Grid
        key="conversions"
        item
        className={paperClassName ? `${classes.topPaper} ${paperClassName}` : classes.topPaper}
      >
        <Paper className={classes.widgetPaper}>
          <Box className={classes.paperHeader}>
            <Box className={classes.metricsRow}>
              {metric1 && (
                <Box className={classes.metricItem}>
                  <Tooltip title={<div style={{ fontSize: '12px' }}>{getPreviousPeriodText(metric1IdAndValue)}</div>}>
                    <Icon className={classes.icon} style={getColorStyle(getTrendColor(metric1IdAndValue))}>{getTrendIcon(metric1IdAndValue)}</Icon>
                  </Tooltip>
                  <Typography className={classes.conversionText} variant="h6" gutterBottom>{metric1IdAndValue.value}</Typography>
                </Box>
              )}
              
              {metric2 && (
                <Box className={classes.metricItem}>
                  <Tooltip title={<div style={{ fontSize: '12px' }}>{getPreviousPeriodText(metric2IdAndValue)}</div>}>
                    <Icon className={classes.icon} style={getColorStyle(getTrendColor(metric2IdAndValue))}>{getTrendIcon(metric2IdAndValue)}</Icon>
                  </Tooltip>
                  <Typography className={classes.conversionText} variant="h6" gutterBottom>{metric2IdAndValue.value}</Typography>
                </Box>
              )}
  
            </Box>
          </Box>
        </Paper>
      </Grid>
    );
  } catch (error) {
    return null;   
  }
 
}

const useStyles = makeStyles((theme) => ({
  widgetPaper: {
    [theme.breakpoints.only("xs")]: {
      height: 90,
      padding: theme.spacing(1),
      paddingRight: theme.spacing(2),
      width: "auto",
      minWidth: "30vw",
    },
    [theme.breakpoints.up("sm")]: {
      height: 80,
      padding: theme.spacing(2),
      width: "auto",
    },
    [theme.breakpoints.only("xl")]: {
      height: 100,
      padding: theme.spacing(2),
      paddingRight: theme.spacing(3),
      width: "auto",
    },
    display: "flex",
    alignItems: "center",
    color: "rgb(135, 131, 131)",
  },
  conversionText: {
    [theme.breakpoints.only("xs")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 16,
    },
    [theme.breakpoints.only("xl")]: {
      fontSize: 20,
    },
    color: "rgb(100, 100, 100)",
    marginBottom: 0,
    fontWeight: 400,
  },
  paperHeader: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  topPaper: {
    [theme.breakpoints.only("xs")]: {
      marginBottom: theme.spacing(1),
      width: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  metricsRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
  metricItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    marginRight: 10,
  },
}));
